import { useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'

export const useGetResources = () => {
  const get = useTypedApiClient({
    path: '/admin/resources',
    method: 'get',
  })

  return useQuery({
    queryKey: ['/admin/resources'],
    queryFn: async () => {
      const { data } = await get({})
      return data
    },
  })
}
